<template>
  <article class="article__content">
    <h1 class="article__title">
      <img :src="img" alt="" />
      {{ $t("grocery.success.title") }}
    </h1>

    <i18n-t keypath="grocery.success.text" tag="p">
      <template #reservationLink>
        <a :href="'/profile/orders/' + props.reservationId">
          #{{ props.reservationId }}
        </a>
      </template>
      <template #ordersLink>
        <a href="/profile/orders">
          {{ $t("grocery.success.ordersLink") }}
        </a>
      </template>
    </i18n-t>

    <div class="article-actions">
      <a href="/" class="btn">{{ $t("grocery.success.backLink") }}</a>
    </div>
  </article>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import imgLt from "../../assets/lt/thanks.svg";
import imgLv from "../../assets/lv/thanks.svg";

const props = defineProps<{
  reservationId: string;
}>();

const { locale } = useI18n();

const img =
  {
    lt: imgLt,
    lv: imgLv,
  }[locale.value] ?? "lt";
</script>
